var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class HallResearchHsm {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        this.framework = framework;
        // other class properties and constructor
        this.initializerSteps = [
            {
                errorCode: 'verifyFailed',
                send: 'PW',
                next: /PW[01]/i,
            },
        ];
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.firmwareVersion = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('FW', /FW[\s:]*(?:Version:)?([\d\.]+)/i, tags);
                return match[1];
            }),
            powerOffRestrictions: ['get'],
            // software version is sent upon power on
            asyncHandlers: {
                regExp: /FW[\s:]*(?:Version:)?([\d\.]+)/i,
                callback: (match) => {
                    this.state.firmwareVersion.update(match[1]);
                },
            },
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`PW`, /PW(\d)/i, tags);
                return match[1] === '1';
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`PW${power ? '1' : '0'}`, /Power(ON|OFF)|PW(\d)/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 8000 : 1000);
                if (power)
                    this.framework.suspend(5000);
                return match[1] ? match[1] === 'ON' : match[2] === '1';
            }),
        };
        this.videoMatrixRoutes = {
            get: (key, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`CV`, /CV(\d+),(\d+)/i, tags);
                return match[2];
            }),
            set: (key, value, tags) => __awaiter(this, void 0, void 0, function* () {
                // Command format is CVoutput, input
                const match = yield this.socket.send(`CV${key},${value}`, /CV(\d+),(\d+)/i, tags);
                return match[2];
            }),
            powerOffRestrictions: ['set', 'get'],
            // The CV command generates multiple responses: one for each output. This
            // command is defined with an asyncHandler so it can process all the responses.
            // Front panel changes also send a CV status response.
            asyncHandlers: {
                regExp: /CV(\d+),(\d+)/i,
                callback: (match) => {
                    this.state.videoMatrixRoutes.update(match[1], match[2]);
                },
            },
        };
        // polling
        this.polls = [{ intervalMs: 5000, controls: ['power'] }];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield CommandSocketInitializer.initialize(this.socket, this.initializerSteps, credentials);
        });
    }
}
// static properties
HallResearchHsm.driverType = 'socketDriver';
HallResearchHsm.key = '-LTZIXYpaRcwn1Be2d0K';
HallResearchHsm.baseSocketOptions = {
    commandExtractor: {
        terminators: ['\r', '\n'],
    },
    sendTerminator: '\r',
};
HallResearchHsm.socketOptions = [
    Object.assign(Object.assign({}, HallResearchHsm.baseSocketOptions), { port: 6324 }),
    Object.assign(Object.assign({}, HallResearchHsm.baseSocketOptions), { port: 4999 }),
];
